import { Link } from 'react-router-dom';
import {
  ClearanceStatusEnum,
  Provider,
  type ProviderConnectionRequest,
  ProviderDetail,
  ProviderLimitedDetail,
} from '../../../api';
import { Avatar } from '../Avatar';
import { ClearanceBadge } from '../ClearanceBadge';

export const ProviderRepresentation = ({
  provider,
  clearanceStatus,
  size = 50,
  showLink = true,
}: {
  provider: ProviderLimitedDetail | ProviderDetail | Provider | ProviderConnectionRequest;
  clearanceStatus?: ClearanceStatusEnum | null;
  size?: number;
  showLink?: boolean;
}) => (
  <div className="d-flex align-items-center">
    <Avatar className="me-3" size={size} image={provider.profile_picture} />
    <div>
      <strong className="d-block">
        {showLink ? (
          <Link to={`/app/healthcare-entity/providers/${provider.id}`}>
            {provider.display_name}
          </Link>
        ) : (
          <span className="text-section-name text-section-name--dark-brand text-section-name--large">
            {provider.display_name}
          </span>
        )}
        {clearanceStatus && <ClearanceBadge className="ms-1" status={clearanceStatus} />}
      </strong>
      <small>{provider.specialties.join(', ')}</small>
    </div>
  </div>
);
